import React from 'react';
import { TopBar } from '../components/TopBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowRight, Shield, MapPin, Lock, Mail } from 'lucide-react';
export function ResourcesPage() {
  const guides = [{
    id: 'crisis-response',
    title: 'Crisis Response Guide',
    description: 'Something suspicious just happened. Get calm, step-by-step guidance for scam calls, unauthorized charges, account takeovers, identity theft, and more.',
    tag: 'Emergency Guide',
    tagColor: 'text-red-700 bg-red-100',
    link: '/crisis-help',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#fff1f1] to-[#ffe4e4] flex items-center justify-center" data-id="element-4737">
          <AlertTriangle size={64} className="text-red-600" data-id="element-4738" />
        </div>
  }, {
    id: 'ca-privacy',
    title: "California Resident's Guide to Privacy & Opt-Out",
    description: 'Learn how to exercise your CCPA rights, use the new DROP tool to delete your data from brokers, and enable OOPS for automatic opt-outs.',
    tag: 'Privacy & Opt-Out',
    tagColor: 'text-[#631bb7] bg-[#f3e8ff]',
    link: '/resources/ca-guide',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#f5f0ff] to-[#ede0ff] flex items-center justify-center p-8" data-id="element-4739">
          <img src="https://cdn.magicpatterns.com/uploads/rEBPBLjGsXRNeHWosHkCNx/Gemini_Generated_Image_j7hwgij7hwgij7hw.png" alt="California Map" className="w-full h-full object-contain drop-shadow-md" data-id="element-4740" />
        </div>
  }, {
    id: 'spam-guide',
    title: 'Reducing Spam and Junk Mail',
    description: 'Push back against unwanted emails, texts, calls, and physical mail using tools you already have on your phone or computer.',
    tag: 'Spam & Junk',
    tagColor: 'text-[#01ced1] bg-[#e0fafa]',
    link: '/resources/spam-guide',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#e0fafa] to-[#c5f5f5] flex items-center justify-center" data-id="element-4741">
          <Mail size={64} className="text-[#01ced1]" data-id="element-4742" />
        </div>
  }, {
    id: 'family-safety',
    title: 'Family Digital Safety Plan',
    description: 'A comprehensive framework for setting up parental controls, managing screen time, and having constructive conversations about online safety with your kids.',
    tag: 'Family Safety',
    tagColor: 'text-blue-700 bg-blue-100',
    link: '#',
    illustration: <div className="w-full h-full bg-gradient-to-br from-[#eff6ff] to-[#dbeafe] flex items-center justify-center" data-id="element-4743">
          <Shield size={64} className="text-blue-600" data-id="element-4744" />
        </div>
  }];
  return <div className="min-h-screen w-full bg-white font-sans flex flex-col" data-id="element-4745">
      <TopBar data-id="element-4746" />
      <Header data-id="element-4747" />

      {/* Hero Section */}
      <section className="bg-[#1a0647] text-white py-20 px-6 text-center" data-id="element-4748">
        <div className="max-w-4xl mx-auto" data-id="element-4749">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-4750">
            <span className="text-white" data-id="element-4751">Caveo </span>
            <span className="text-[#b063ff]" data-id="element-4752">Resources</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-4753">
            Practical guides to help you and your family stay safe, informed,
            and in control online.
          </p>
        </div>
      </section>

      {/* Featured Guides Section */}
      <section className="py-16 md:py-24 px-6 md:px-12 bg-gray-50 flex-grow" data-id="element-4754">
        <div className="max-w-7xl mx-auto" data-id="element-4755">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111111] mb-10" data-id="element-4756">
            Featured Guides
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4757">
            {guides.map(guide => <Link key={guide.id} to={guide.link} className="group bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col h-full no-underline" data-id="element-4758">
                {/* Illustration Area */}
                <div className="h-48 w-full overflow-hidden relative" data-id="element-4759">
                  {guide.illustration}
                </div>

                {/* Content Area */}
                <div className="p-8 flex flex-col flex-grow" data-id="element-4760">
                  <div className="mb-4" data-id="element-4761">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${guide.tagColor}`} data-id="element-4762">
                      {guide.tag}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-[#111111] mb-3 group-hover:text-[#631bb7] transition-colors" data-id="element-4763">
                    {guide.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-grow" data-id="element-4764">
                    {guide.description}
                  </p>
                  <div className="flex items-center text-[#631bb7] font-bold text-sm mt-auto" data-id="element-4765">
                    Read Guide{' '}
                    <ArrowRight size={16} className="ml-1.5 transition-transform group-hover:translate-x-1" data-id="element-4766" />
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-4767" />
    </div>;
}